























import { Component, Vue } from 'vue-property-decorator'
import PhoneLogin from './components/phoneLogin.vue'
import QrCodeLogin from './components/qrCodeLogin.vue'

@Component({
  name: 'Login',
  components: {
    PhoneLogin,
    QrCodeLogin
  }
})
export default class extends Vue {
  // 是否为钉钉扫码登录
  private isQrCodeLogin = true;
}
